import client from 'micromodal';
import { useCallback, useState } from 'react';

export const useMicromodal = (id: string) => {
  const [isShow, setIsShow] = useState(false);

  const open = useCallback(() => {
    client.show(id, {
      disableScroll: true,
    });
    setIsShow(true);
  }, [id]);

  const close = useCallback(() => {
    client.close(id);
    setIsShow(false);
  }, [id]);

  return {
    open,
    close,
    id,
    isShow,
  };
};
